/* tslint:disable */
/* eslint-disable */
/**
 * HR Recruiter API — Interview Settings
 * OpenAPI спецификация для настроек процесса интервью (сообщения, дополнительные вопросы). Самодостаточный файл для генерации и документации. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@hr-recruiter.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CompanyQuestion
 */
export interface CompanyQuestion {
    /**
     * Уникальный идентификатор
     * @type {number}
     * @memberof CompanyQuestion
     */
    'id'?: number;
    /**
     * Текст вопроса
     * @type {string}
     * @memberof CompanyQuestion
     */
    'question': string;
    /**
     * Текст ответа на вопрос
     * @type {string}
     * @memberof CompanyQuestion
     */
    'answer'?: string;
    /**
     * Порядковый номер вопроса
     * @type {number}
     * @memberof CompanyQuestion
     */
    'orderIndex': number;
}
/**
 * 
 * @export
 * @interface CompanyQuestions
 */
export interface CompanyQuestions {
    /**
     * Уникальный идентификатор
     * @type {number}
     * @memberof CompanyQuestions
     */
    'id'?: number;
    /**
     * Список вопросов о компании
     * @type {Array<CompanyQuestion>}
     * @memberof CompanyQuestions
     */
    'questions': Array<CompanyQuestion>;
    /**
     * Дата создания
     * @type {string}
     * @memberof CompanyQuestions
     */
    'createdAt'?: string;
    /**
     * Дата последнего обновления
     * @type {string}
     * @memberof CompanyQuestions
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface CompanyQuestionsRequest
 */
export interface CompanyQuestionsRequest {
    /**
     * Список вопросов о компании
     * @type {Array<CompanyQuestion>}
     * @memberof CompanyQuestionsRequest
     */
    'questions': Array<CompanyQuestion>;
}
/**
 * 
 * @export
 * @interface CompletionMessages
 */
export interface CompletionMessages {
    /**
     * Уникальный идентификатор
     * @type {number}
     * @memberof CompletionMessages
     */
    'id'?: number;
    /**
     * Список завершающих сообщений
     * @type {Array<InterviewMessage>}
     * @memberof CompletionMessages
     */
    'messages': Array<InterviewMessage>;
    /**
     * Дата создания
     * @type {string}
     * @memberof CompletionMessages
     */
    'createdAt'?: string;
    /**
     * Дата последнего обновления
     * @type {string}
     * @memberof CompletionMessages
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface CompletionMessagesRequest
 */
export interface CompletionMessagesRequest {
    /**
     * Список завершающих сообщений
     * @type {Array<InterviewMessage>}
     * @memberof CompletionMessagesRequest
     */
    'messages': Array<InterviewMessage>;
}
/**
 * 
 * @export
 * @interface InterviewMessage
 */
export interface InterviewMessage {
    /**
     * Уникальный идентификатор
     * @type {number}
     * @memberof InterviewMessage
     */
    'id'?: number;
    /**
     * Текст сообщения
     * @type {string}
     * @memberof InterviewMessage
     */
    'text': string;
    /**
     * Порядковый номер сообщения
     * @type {number}
     * @memberof InterviewMessage
     */
    'orderIndex': number;
}
/**
 * 
 * @export
 * @interface TestMessages
 */
export interface TestMessages {
    /**
     * 
     * @type {InterviewMessage}
     * @memberof TestMessages
     */
    'testPreMessage': InterviewMessage;
    /**
     * 
     * @type {InterviewMessage}
     * @memberof TestMessages
     */
    'testMessage'?: InterviewMessage;
    /**
     * Позитивные ответы на тест (может быть несколько сообщений)
     * @type {Array<InterviewMessage>}
     * @memberof TestMessages
     */
    'testPositiveResponses'?: Array<InterviewMessage>;
    /**
     * Негативные ответы на тест (может быть несколько сообщений)
     * @type {Array<InterviewMessage>}
     * @memberof TestMessages
     */
    'testNegativeResponses'?: Array<InterviewMessage>;
}
/**
 * 
 * @export
 * @interface TestMessagesRequest
 */
export interface TestMessagesRequest {
    /**
     * 
     * @type {InterviewMessage}
     * @memberof TestMessagesRequest
     */
    'testPreMessage': InterviewMessage;
    /**
     * 
     * @type {InterviewMessage}
     * @memberof TestMessagesRequest
     */
    'testMessage'?: InterviewMessage;
    /**
     * Позитивные ответы на тест (может быть несколько сообщений)
     * @type {Array<InterviewMessage>}
     * @memberof TestMessagesRequest
     */
    'testPositiveResponses'?: Array<InterviewMessage>;
    /**
     * Негативные ответы на тест (может быть несколько сообщений)
     * @type {Array<InterviewMessage>}
     * @memberof TestMessagesRequest
     */
    'testNegativeResponses'?: Array<InterviewMessage>;
}
/**
 * 
 * @export
 * @interface WelcomeMessages
 */
export interface WelcomeMessages {
    /**
     * Уникальный идентификатор
     * @type {number}
     * @memberof WelcomeMessages
     */
    'id'?: number;
    /**
     * Список вступительных сообщений
     * @type {Array<InterviewMessage>}
     * @memberof WelcomeMessages
     */
    'messages': Array<InterviewMessage>;
    /**
     * Дата создания
     * @type {string}
     * @memberof WelcomeMessages
     */
    'createdAt'?: string;
    /**
     * Дата последнего обновления
     * @type {string}
     * @memberof WelcomeMessages
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface WelcomeMessagesRequest
 */
export interface WelcomeMessagesRequest {
    /**
     * Список вступительных сообщений
     * @type {Array<InterviewMessage>}
     * @memberof WelcomeMessagesRequest
     */
    'messages'?: Array<InterviewMessage>;
}

/**
 * InterviewSettingsApi - axios parameter creator
 * @export
 */
export const InterviewSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Возвращает текущие вопросы о компании для предварительного просмотра в CRM. Доступно для суперадминистраторов, администраторов и рекрутеров.
         * @summary Получить вопросы о компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyQuestions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interviews/company-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает текущие завершающие сообщения для предварительного просмотра в CRM
         * @summary Получить завершающие сообщения
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletionMessages: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interviews/completion-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает тестовое сообщение и ответы (позитивные/негативные) для проверки микрофона
         * @summary Получить тестовые сообщения (отдельно от welcome)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestMessages: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interviews/test-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает текущие вступительные сообщения для предварительного просмотра в CRM
         * @summary Получить вступительные сообщения
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWelcomeMessages: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/interviews/welcome-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет вопросы о компании для интервью. Доступно для суперадминистраторов, администраторов и рекрутеров.
         * @summary Обновить вопросы о компании
         * @param {CompanyQuestionsRequest} companyQuestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyQuestions: async (companyQuestionsRequest: CompanyQuestionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyQuestionsRequest' is not null or undefined
            assertParamExists('updateCompanyQuestions', 'companyQuestionsRequest', companyQuestionsRequest)
            const localVarPath = `/interviews/company-questions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(companyQuestionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет завершающие сообщения интервью
         * @summary Обновить завершающие сообщения
         * @param {CompletionMessagesRequest} completionMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompletionMessages: async (completionMessagesRequest: CompletionMessagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'completionMessagesRequest' is not null or undefined
            assertParamExists('updateCompletionMessages', 'completionMessagesRequest', completionMessagesRequest)
            const localVarPath = `/interviews/completion-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completionMessagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет тестовое сообщение и списки ответов
         * @summary Обновить тестовые сообщения
         * @param {TestMessagesRequest} testMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestMessages: async (testMessagesRequest: TestMessagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testMessagesRequest' is not null or undefined
            assertParamExists('updateTestMessages', 'testMessagesRequest', testMessagesRequest)
            const localVarPath = `/interviews/test-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(testMessagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Обновляет вступительные сообщения интервью
         * @summary Обновить вступительные сообщения
         * @param {WelcomeMessagesRequest} welcomeMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWelcomeMessages: async (welcomeMessagesRequest: WelcomeMessagesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'welcomeMessagesRequest' is not null or undefined
            assertParamExists('updateWelcomeMessages', 'welcomeMessagesRequest', welcomeMessagesRequest)
            const localVarPath = `/interviews/welcome-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication AdminAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(welcomeMessagesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterviewSettingsApi - functional programming interface
 * @export
 */
export const InterviewSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterviewSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * Возвращает текущие вопросы о компании для предварительного просмотра в CRM. Доступно для суперадминистраторов, администраторов и рекрутеров.
         * @summary Получить вопросы о компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompanyQuestions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyQuestions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompanyQuestions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSettingsApi.getCompanyQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает текущие завершающие сообщения для предварительного просмотра в CRM
         * @summary Получить завершающие сообщения
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompletionMessages(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletionMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompletionMessages(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSettingsApi.getCompletionMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает тестовое сообщение и ответы (позитивные/негативные) для проверки микрофона
         * @summary Получить тестовые сообщения (отдельно от welcome)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestMessages(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestMessages(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSettingsApi.getTestMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Возвращает текущие вступительные сообщения для предварительного просмотра в CRM
         * @summary Получить вступительные сообщения
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWelcomeMessages(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WelcomeMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWelcomeMessages(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSettingsApi.getWelcomeMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет вопросы о компании для интервью. Доступно для суперадминистраторов, администраторов и рекрутеров.
         * @summary Обновить вопросы о компании
         * @param {CompanyQuestionsRequest} companyQuestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompanyQuestions(companyQuestionsRequest: CompanyQuestionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompanyQuestions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompanyQuestions(companyQuestionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSettingsApi.updateCompanyQuestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет завершающие сообщения интервью
         * @summary Обновить завершающие сообщения
         * @param {CompletionMessagesRequest} completionMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCompletionMessages(completionMessagesRequest: CompletionMessagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CompletionMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCompletionMessages(completionMessagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSettingsApi.updateCompletionMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет тестовое сообщение и списки ответов
         * @summary Обновить тестовые сообщения
         * @param {TestMessagesRequest} testMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTestMessages(testMessagesRequest: TestMessagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTestMessages(testMessagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSettingsApi.updateTestMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Обновляет вступительные сообщения интервью
         * @summary Обновить вступительные сообщения
         * @param {WelcomeMessagesRequest} welcomeMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWelcomeMessages(welcomeMessagesRequest: WelcomeMessagesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WelcomeMessages>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWelcomeMessages(welcomeMessagesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSettingsApi.updateWelcomeMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterviewSettingsApi - factory interface
 * @export
 */
export const InterviewSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterviewSettingsApiFp(configuration)
    return {
        /**
         * Возвращает текущие вопросы о компании для предварительного просмотра в CRM. Доступно для суперадминистраторов, администраторов и рекрутеров.
         * @summary Получить вопросы о компании
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyQuestions(options?: RawAxiosRequestConfig): AxiosPromise<CompanyQuestions> {
            return localVarFp.getCompanyQuestions(options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает текущие завершающие сообщения для предварительного просмотра в CRM
         * @summary Получить завершающие сообщения
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletionMessages(options?: RawAxiosRequestConfig): AxiosPromise<CompletionMessages> {
            return localVarFp.getCompletionMessages(options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает тестовое сообщение и ответы (позитивные/негативные) для проверки микрофона
         * @summary Получить тестовые сообщения (отдельно от welcome)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestMessages(options?: RawAxiosRequestConfig): AxiosPromise<TestMessages> {
            return localVarFp.getTestMessages(options).then((request) => request(axios, basePath));
        },
        /**
         * Возвращает текущие вступительные сообщения для предварительного просмотра в CRM
         * @summary Получить вступительные сообщения
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWelcomeMessages(options?: RawAxiosRequestConfig): AxiosPromise<WelcomeMessages> {
            return localVarFp.getWelcomeMessages(options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет вопросы о компании для интервью. Доступно для суперадминистраторов, администраторов и рекрутеров.
         * @summary Обновить вопросы о компании
         * @param {CompanyQuestionsRequest} companyQuestionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyQuestions(companyQuestionsRequest: CompanyQuestionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompanyQuestions> {
            return localVarFp.updateCompanyQuestions(companyQuestionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет завершающие сообщения интервью
         * @summary Обновить завершающие сообщения
         * @param {CompletionMessagesRequest} completionMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompletionMessages(completionMessagesRequest: CompletionMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<CompletionMessages> {
            return localVarFp.updateCompletionMessages(completionMessagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет тестовое сообщение и списки ответов
         * @summary Обновить тестовые сообщения
         * @param {TestMessagesRequest} testMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestMessages(testMessagesRequest: TestMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestMessages> {
            return localVarFp.updateTestMessages(testMessagesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Обновляет вступительные сообщения интервью
         * @summary Обновить вступительные сообщения
         * @param {WelcomeMessagesRequest} welcomeMessagesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWelcomeMessages(welcomeMessagesRequest: WelcomeMessagesRequest, options?: RawAxiosRequestConfig): AxiosPromise<WelcomeMessages> {
            return localVarFp.updateWelcomeMessages(welcomeMessagesRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterviewSettingsApi - object-oriented interface
 * @export
 * @class InterviewSettingsApi
 * @extends {BaseAPI}
 */
export class InterviewSettingsApi extends BaseAPI {
    /**
     * Возвращает текущие вопросы о компании для предварительного просмотра в CRM. Доступно для суперадминистраторов, администраторов и рекрутеров.
     * @summary Получить вопросы о компании
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewSettingsApi
     */
    public getCompanyQuestions(options?: RawAxiosRequestConfig) {
        return InterviewSettingsApiFp(this.configuration).getCompanyQuestions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает текущие завершающие сообщения для предварительного просмотра в CRM
     * @summary Получить завершающие сообщения
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewSettingsApi
     */
    public getCompletionMessages(options?: RawAxiosRequestConfig) {
        return InterviewSettingsApiFp(this.configuration).getCompletionMessages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает тестовое сообщение и ответы (позитивные/негативные) для проверки микрофона
     * @summary Получить тестовые сообщения (отдельно от welcome)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewSettingsApi
     */
    public getTestMessages(options?: RawAxiosRequestConfig) {
        return InterviewSettingsApiFp(this.configuration).getTestMessages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Возвращает текущие вступительные сообщения для предварительного просмотра в CRM
     * @summary Получить вступительные сообщения
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewSettingsApi
     */
    public getWelcomeMessages(options?: RawAxiosRequestConfig) {
        return InterviewSettingsApiFp(this.configuration).getWelcomeMessages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет вопросы о компании для интервью. Доступно для суперадминистраторов, администраторов и рекрутеров.
     * @summary Обновить вопросы о компании
     * @param {CompanyQuestionsRequest} companyQuestionsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewSettingsApi
     */
    public updateCompanyQuestions(companyQuestionsRequest: CompanyQuestionsRequest, options?: RawAxiosRequestConfig) {
        return InterviewSettingsApiFp(this.configuration).updateCompanyQuestions(companyQuestionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет завершающие сообщения интервью
     * @summary Обновить завершающие сообщения
     * @param {CompletionMessagesRequest} completionMessagesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewSettingsApi
     */
    public updateCompletionMessages(completionMessagesRequest: CompletionMessagesRequest, options?: RawAxiosRequestConfig) {
        return InterviewSettingsApiFp(this.configuration).updateCompletionMessages(completionMessagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет тестовое сообщение и списки ответов
     * @summary Обновить тестовые сообщения
     * @param {TestMessagesRequest} testMessagesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewSettingsApi
     */
    public updateTestMessages(testMessagesRequest: TestMessagesRequest, options?: RawAxiosRequestConfig) {
        return InterviewSettingsApiFp(this.configuration).updateTestMessages(testMessagesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Обновляет вступительные сообщения интервью
     * @summary Обновить вступительные сообщения
     * @param {WelcomeMessagesRequest} welcomeMessagesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InterviewSettingsApi
     */
    public updateWelcomeMessages(welcomeMessagesRequest: WelcomeMessagesRequest, options?: RawAxiosRequestConfig) {
        return InterviewSettingsApiFp(this.configuration).updateWelcomeMessages(welcomeMessagesRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



